const floordiv = (a, b) => (a / b) | 0;
export default floordiv;
